import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClaimsDashboardComponent } from './pages/common/claims-dashboard/claims-dashboard.component';
import { WizardComponent } from './pages/wizard/wizard.component';
import { ClaimDetailComponent } from './pages/common/claim-detail/claim-detail.component';
import { OutlineExposureToDustComponent } from './pages/asbestosis/exposure/outline-exposure-to-dust/outline-exposure-to-dust.component';
import { EstablishBreachOfDutyComponent } from './pages/asbestosis/investigation/establish-breach-of-duty/establish-breach-of-duty.component';
import { EstablishCausationComponent } from './pages/asbestosis/investigation/establish-causation/establish-causation.component';
import { ActivityListingComponent } from './pages/asbestosis/exposure/activity-listing/activity-listing.component';
import { AuthGuard } from './guards/auth.guard';
import { RadiologicalProgressionAsbestosisComponent } from './pages/asbestosis/radiological-progression-asbestosis/radiological-progression-asbestosis.component';
import { RadiologicalProgressionChartAsbestosisComponent } from './pages/asbestosis/radiological-progression-chart/radiological-progression-chart-asbestosis.component';

const routes: Routes = [
  {
    path: 'claims',
    component: ClaimsDashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'claimForm',
    component: WizardComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'claimDetail/:id/:tab',
    component: ClaimDetailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'claimDetail/:id',
    component: ClaimDetailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'claimForm/:claimId',
    component: WizardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'asbestosis/exposure/outline-exposure-to-dust/:claimId/:taskId',
    component: ActivityListingComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'asbestosis/exposure/outline-exposure-to-dust/addActivity/:claimId/:taskId',
    component: OutlineExposureToDustComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'asbestosis/exposure/outline-exposure-to-dust/editActivity/:claimId/:taskId/:activityId',
    component: OutlineExposureToDustComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'asbestosis/apportionment/assess-contribution-to-costs/:claimId/:taskId',
    component: WizardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'asbestosis/investigation/establish-breach-of-duty/:claimId/:taskId',
    component: EstablishBreachOfDutyComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'asbestosis/investigation/establish-causation/:claimId/:taskId',
    component: EstablishCausationComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'asbestosis/radiological-progression/create-chart/:claimId',
    component: RadiologicalProgressionAsbestosisComponent,
  },
  {
    path: 'asbestosis/radiological-progression/edit-chart/:claimId/:radProgressionId',
    component: RadiologicalProgressionAsbestosisComponent,
  },
  {
    path: 'asbestosis/radiological-progression/view-chart/:claimId/:radProgressionId/:title',
    component: RadiologicalProgressionChartAsbestosisComponent,
  },
  {
    path: 'nihl',
    loadChildren: () => import('./pages/nihl/nihl.module').then(mod => mod.NihlModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'mesothelioma',
    loadChildren: () => import('./pages/mesothelioma/mesothelioma.module').then(mod => mod.MesotheliomaModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'pleural-thickening',
    loadChildren: () => import('./pages/pleural-thickening/pleural-thickening.module').then(mod => mod.PleuralthickeningModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'carcinoma-of-the-lung',
    loadChildren: () => import('./pages/carcinoma-of-the-lung/carcinoma-of-the-lung.module').then(mod => mod.CarcinomaofthelungModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'insights',
    loadChildren: () => import('./pages/common/claims-insights/claims-insights.module').then(mod => mod.ClaimsInsightsModule),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: 'claims'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true
   })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
